import React from "react";
import styled from "styled-components";
import { colors } from "../utils/helpers";
import Pasos from "./Pasos";
import Itinerario from "./Itinerario";
import ForecastView from "./ForecastView";
import Bolo from "./Bolo";
import { fechas } from "../data/fechas";

// import moment from "moment";
// import "moment/locale/es";

const FichaContainer = styled.section`
	max-width: 1220px;
	padding: 2em;
	margin: 0 auto;
`;

const Dia = styled.h1`
	font-size: 1.4em;
	font-family: ${colors.stackSerif};
	color: ${colors.grisoscuro};
	font-weight: 500;
	margin: 0.8em;
	text-align: center;
	@media (max-width: 720px) {
		font-size: 1.8em;
	}
	@media (min-width: 880px) {
		font-size: 1.8em;
	}
	@media (min-width: 920px) {
		font-size: 2em;
	}
`;

const FlexCont = styled.div`
	@media (min-width: 720px) {
		display: flex;
		justify-content: space-between;
	}
`;
const ItinerarioCont = styled.div`
	padding-bottom: 2em;
	@media (min-width: 720px) {
		width: 42%;
	}
`;
const PasosCont = styled.div`
	padding-bottom: 2em;
	@media (min-width: 720px) {
		width: 42%;
	}
`;

const NombreCompleto = styled.h4`
	font-size: 1em;
	line-height: 1.4em;
	font-family: ${colors.stackSerif};
	color: ${colors.grisoscuro};
	font-weight: 300;
	margin: 0.8em;
	text-align: center;
	padding-bottom: 2em;
`;

const Sede = styled.h4`
	font-size: 1.1em;
	line-height: 1.4em;
	font-family: ${colors.stackSerif};
	color: ${colors.grisoscuro};
	font-weight: 400;
	margin: 0.8em;
	text-align: center;
`;

const Enlace = styled.h4`
	font-size: 1.1em;
	line-height: 1.4em;
	font-family: ${colors.stackSerif};
	color: ${colors.main};
	font-weight: 500;
	margin: 0.8em;
	text-align: center;
`;

const Link = styled.a`
	color: ${colors.main};
	text-decoration: none;
`;

const svgStyle = {
	verticalAlign: "middle",
	paddingLeft: "0.5em"
};

class Ficha extends React.Component {
	render() {
		return (
			<div className="container ficha">
				<FichaContainer className="fichaContainer">
					<Dia>{this.props.pro_obj.nombre}</Dia>
					<Sede>{this.props.pro_obj.sede}</Sede>

					<NombreCompleto>{this.props.pro_obj.nombrecompleto}</NombreCompleto>
					<Enlace>
						<Link href={this.props.pro_obj.web} target="_blank">
							Ver Ficha Completa en Diario Cofrade
							<svg
								width="24"
								height="20"
								viewBox="0 0 24 20"
								fill={colors.main}
								style={svgStyle}
							>
								<path d="M15.7 9.7L22 3.4V8h2V0h-8v2h4.6l-6.3 6.3z" />
								<path d="M22 18H2V4h10V0H0v20h24v-8h-2z" />
							</svg>
						</Link>
					</Enlace>
					<FlexCont>
						<PasosCont>
							<ForecastView
								cityName={"Cádiz, es"}
								forecast={this.props.forecast}
								loading={this.props.loading}
								onPressRefresh={() => this.props.getForecastData()}
								dia_act={fechas[this.props.dia_act].fecha}
							/>
							<Bolo texto="Penitentes" />
							<Pasos
								pasos={this.props.pro_obj.pasos}
								penitentes={this.props.pro_obj.penitentes}
								cargadores={this.props.pro_obj.cargadores}
								distancia={this.props.pro_obj.distancia}
							/>
						</PasosCont>

						<ItinerarioCont>
							<Bolo texto="Itinerario" />
							<Itinerario
								pro_obj={this.props.pro_obj}
								dia={this.props.dia}
								dia_act={this.props.dia_act}
							/>
						</ItinerarioCont>
					</FlexCont>
				</FichaContainer>
			</div>
		);
	}
}

export default Ficha;



// WEBPACK FOOTER //
// ./src/components/Ficha.js